import React from 'react';
import './SearchControls.css';

interface SearchControlsProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  dateValue: string;
  onDateChange: (value: string) => void;
  onExport: () => void;
}

const SearchControls: React.FC<SearchControlsProps> = ({
  searchValue,
  onSearchChange,
  dateValue,
  onDateChange,
  onExport
}) => {
  return (
    <div className="search-controls">
      <input
        type="text"
        className="search-input"
        placeholder="Search transactions..."
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <input
        type="date"
        className="date-picker"
        value={dateValue}
        onChange={(e) => onDateChange(e.target.value)}
      />
      <button className="export-btn" onClick={onExport}>
        Export CSV
      </button>
    </div>
  );
};

export default SearchControls;
